export const DEFAULT_UNIT_OPTIONS = [
  { value: "gram", label: "Gram" },
  { value: "kg", label: "Kilogram", factor: 1000, base_unit_value: "gram", base_unit_label: "Gram" },
  { value: "pcs", label: "Pcs" },
  { value: "ml", label: "Ml" },
  { value: "l", label: "Liter", factor: 1000, base_unit_value: "ml", base_unit_label: "Ml" }
];

export const toUnitOptions = (units = []) => {
  if (!Array.isArray(units) || units.length === 0) return DEFAULT_UNIT_OPTIONS;

  return units.map((unit) => ({
    value: unit.value,
    label: unit.label || unit.name || unit.value,
    name: unit.name,
    factor: Number(unit.factor || 1),
    base_unit_id: unit.base_unit_id,
    base_unit_value: unit.base_unit_value,
    base_unit_label: unit.base_unit_label
  }));
};
